import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { Submotive2DataProps } from './props';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { ParamWithNestedParent } from '../../../../../../shared/types/param';
import {
    asyncGetLastCodeSuffixParam,
    asyncGetParams,
} from '../../../../../../services/param.service';
import { useParams } from 'react-router-dom';

export const useSubmotive2Data = ({
    data,
    onChangeData,
    onChangeFormik,
}: Submotive2DataProps) => {
    const [newCode, setNewCode] = useState<string>('');
    const [types, setTypes] = useState<ISelect[]>([]);
    const [motives, setMotives] = useState<ISelect[]>([]);
    const [submotives1, setSubmotives1] = useState<ISelect[]>([]);

    const { idSubmotive2 } = useParams();
    const onSubmit = (data: ParamWithNestedParent) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(idSubmotive2),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('code', data?.code || newCode);
        formik?.setFieldValue('class', data?.class || ParamEnum.PQR_SUBMOTIVE2);
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('active', data?.active ?? true);
        formik?.setFieldValue('extra2', data?.extra2 || '');
        formik?.setFieldValue('parent', (data?.parent as ISelect)?.id || '');
        formik?.setFieldValue(
            'nestedParent',
            ((data?.parent as ISelect)?.parent as ISelect)?.id || ''
        );
        formik?.setFieldValue(
            'nestedParent2',
            (((data?.parent as ISelect)?.parent as ISelect)?.parent as ISelect)
                ?.id || ''
        );
    }, [data, newCode]);

    useEffect(() => {
        asyncGetLastCodeSuffixParam(ParamEnum.PQR_SUBMOTIVE2).then(
            (res: any) => {
                setNewCode(res?.items);
            }
        );
    }, [newCode]);

    useEffect(() => {
        if (Boolean(formik.values.nestedParent2)) {
            asyncGetParams(
                ParamEnum.PQR_MOTIVE,
                undefined,
                formik.values.nestedParent2
            ).then((items) => {
                setMotives(items);
            });
            if (
                !data ||
                !Boolean(
                    ((data?.parent as ISelect)?.parent as ISelect)
                        ?.parent as ISelect
                )
            ) {
                formik?.setFieldValue('nestedParent', '');
            }
        }
    }, [formik.values.nestedParent2, types]);

    useEffect(() => {
        if (Boolean(formik.values.nestedParent)) {
            asyncGetParams(
                ParamEnum.PQR_SUBMOTIVE1,
                undefined,
                formik.values.nestedParent
            ).then((items) => {
                setSubmotives1(items);
            });
            if (
                !data ||
                !Boolean((data?.parent as ISelect)?.parent as ISelect)
            ) {
                formik?.setFieldValue('parent', '');
            }
        }
    }, [formik.values.nestedParent, motives]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_TYPE).then((items) => setTypes(items));
    }, []);

    return {
        formik,
        types,
        motives,
        submotives1,
    };
};
